define(["require", "exports", "tslib", "mobx", "react", "../components", "../components/blocks", "../model/services/EventManager", "../model/services/ServiceError", "./Events"], function (require, exports, tslib_1, mobx_1, React, components_1, blocks_1, EventManager_1, ServiceError_1, Events_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ModalStore = exports.ModalResponse = void 0;
    React = tslib_1.__importStar(React);
    var ModalResponse;
    (function (ModalResponse) {
        ModalResponse[ModalResponse["No"] = 0] = "No";
        ModalResponse[ModalResponse["Yes"] = 1] = "Yes";
        ModalResponse[ModalResponse["Cancel"] = 2] = "Cancel";
    })(ModalResponse || (exports.ModalResponse = ModalResponse = {}));
    class ModalStore {
        constructor(storeManager) {
            Object.defineProperty(this, "storeManager", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isOpen", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "title", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "titleStyle", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "body", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "actions", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            Object.defineProperty(this, "selectedAction", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: -1
            });
            Object.defineProperty(this, "onNo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (e) => {
                    this.isOpen = false;
                    this.selectedAction = ModalResponse.No;
                }
            });
            Object.defineProperty(this, "onYes", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (e) => {
                    this.isOpen = false;
                    this.selectedAction = ModalResponse.Yes;
                }
            });
            Object.defineProperty(this, "onCancel", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (e) => {
                    this.isOpen = false;
                    this.selectedAction = ModalResponse.Cancel;
                }
            });
            (0, mobx_1.makeObservable)(this);
            this.storeManager = storeManager;
            EventManager_1.EventManager.Instance.on(Events_1.ERROR_EVENT, (err) => {
                this.createErrorModal(err);
            });
            EventManager_1.EventManager.Instance.on(Events_1.SERVICE_REQUEST_ERROR, (url, err) => {
                const ignoreRoutes = ["authenticate"];
                console.log({
                    url,
                    ignoreRoutes,
                    result: ignoreRoutes.indexOf(url === null || url === void 0 ? void 0 : url.toLowerCase())
                });
                if ((err === null || err === void 0 ? void 0 : err.Code) != 401 && ignoreRoutes.indexOf(url === null || url === void 0 ? void 0 : url.toLowerCase()) == -1) {
                    this.createErrorModal(err);
                }
            });
            EventManager_1.EventManager.Instance.on("entity.*.error", (serviceName, err) => {
                this.createErrorModal(err);
            });
        }
        createYesNoCancelModal(props) {
            return new Promise((resolve, reject) => {
                if (!this.isOpen) {
                    this.selectedAction = -1;
                    this.title = props.title;
                    this.body = React.createElement("div", { style: { paddingTop: 10, overflowY: "auto" } }, props.msg);
                    this.actions = [];
                    if (props.enableCancel) {
                        this.actions.push(React.createElement(blocks_1.CtaButton, { label: props.cancelLabel || "Cancel", color: "primary", onClick: this.onCancel }));
                    }
                    if (props.enableNo) {
                        this.actions.push(React.createElement(blocks_1.CtaButton, { label: props.noLabel || "No", color: "primary", onClick: this.onNo }));
                    }
                    if (props.enableYes) {
                        this.actions.push(React.createElement(blocks_1.CtaButton, { label: props.yesLabel || "Yes", color: "primary", autoFocus: true, onClick: this.onYes }));
                    }
                    this.isOpen = true;
                    const watcher = (0, mobx_1.autorun)(() => {
                        if (this.selectedAction > -1) {
                            resolve(this.selectedAction);
                        }
                    });
                }
                else {
                    reject("Modal already open");
                }
            });
        }
        createErrorModal(err) {
            return new Promise((resolve, reject) => {
                if (!this.isOpen) {
                    this.selectedAction = -1;
                    this.title =
                        (err instanceof ServiceError_1.ServiceError ? err.Message : err.name) ||
                            "Error";
                    this.titleStyle = this.createTitleStyle(err);
                    this.body = React.createElement(components_1.ErrorReportView, { error: err });
                    this.actions = [
                        React.createElement(blocks_1.CtaButton, { label: "Ok", color: "primary", autoFocus: true, onClick: this.onYes })
                    ];
                    this.isOpen = true;
                    const watcher = (0, mobx_1.autorun)(() => {
                        if (this.selectedAction > -1) {
                            resolve(this.selectedAction);
                        }
                    });
                }
                else {
                    reject("Modal already open");
                }
            });
        }
        createInfoModal(title, content) {
            return new Promise((resolve, reject) => {
                if (!this.isOpen) {
                    this.selectedAction = -1;
                    this.titleStyle = this.createTitleStyle();
                    this.title = title;
                    this.body = content;
                    this.actions = [
                        React.createElement(blocks_1.CtaButton, { label: "Ok", color: "primary", autoFocus: true, onClick: this.onYes })
                    ];
                    this.isOpen = true;
                    const watcher = (0, mobx_1.autorun)(() => {
                        if (this.selectedAction > -1) {
                            resolve(this.selectedAction);
                        }
                    });
                }
                else {
                    reject("Modal already open");
                }
            });
        }
        createTitleStyle(err) {
            const infoStyle = {
                fontSize: "1.1rem",
                backgroundColor: "#1ab3e3",
                color: "white"
            };
            const warnStyle = {
                fontSize: "1.1rem",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                backgroundColor: "#FFCC33",
                color: "white"
            };
            if (err) {
                if (err instanceof ServiceError_1.ServiceError) {
                    if (err.Level == ServiceError_1.ServiceErrorLevel.Info) {
                        return infoStyle;
                    }
                    else if (err.Level == ServiceError_1.ServiceErrorLevel.Warning) {
                        return warnStyle;
                    }
                }
                return null;
            }
            return infoStyle;
        }
    }
    exports.ModalStore = ModalStore;
    tslib_1.__decorate([
        mobx_1.observable
    ], ModalStore.prototype, "isOpen", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ModalStore.prototype, "title", void 0);
    tslib_1.__decorate([
        mobx_1.observable.shallow
    ], ModalStore.prototype, "titleStyle", void 0);
    tslib_1.__decorate([
        mobx_1.observable.ref
    ], ModalStore.prototype, "body", void 0);
    tslib_1.__decorate([
        mobx_1.observable.ref
    ], ModalStore.prototype, "actions", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ModalStore.prototype, "selectedAction", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ModalStore.prototype, "onNo", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ModalStore.prototype, "onYes", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ModalStore.prototype, "onCancel", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ModalStore.prototype, "createYesNoCancelModal", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ModalStore.prototype, "createErrorModal", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ModalStore.prototype, "createInfoModal", null);
});
